module.exports = __webpack_public_path__ + "static/media/def3.64b50607.jpg";